import { LayoutConnectMap } from '..'
import { SizeTracker } from '../../common/SizeTracker'
import Content from './contentConnectMap'
import { HeaderConnectMap } from './headerConnectMap'
import { Header } from './headerConnectMap/Header'

const EntityMap = () => {
  return (
    <LayoutConnectMap
      renderTopComponent={() => <Header />}
      renderBottomComponent={() => (
        <SizeTracker renderTopComponent={() => <HeaderConnectMap />}>
          {(size) => {
            return (
              <div
                className="positionRelative"
                style={{ height: `calc(100% - ${size.height}px)` }}
              >
                <Content />
              </div>
            )
          }}
        </SizeTracker>
      )}
    />
  )
}

export default EntityMap
